import i18n from '@yandex-int/i18n';
import * as keyset from 'i18n/AccountLinking';

import { UpdateOAuthAppSettingsField } from '../../types';
const t = i18n(keyset);

export default {
    name: t('label-name'),
    clientId: t('label-client_id'),
    clientSecret: t('label-client_secret'),
    authorizationUrl: t('label-auth_url'),
    tokenUrl: t('label-token_url'),
    refreshTokenUrl: t('label-refresh_token_url'),
    scope: t('label-scope'),
    yandexClientId: t('label-yandex_client_id'),
} as Record<UpdateOAuthAppSettingsField, string>;
